import request from '@/utils/request'
import { disPostParams } from '@/utils/common.js'
import { getId } from '@/utils/auth'

export function extractlist() {
    let data = {
        spreaderId: getId()
    }
    return request({
        url: "/spreader/sextract/list",
        headers: {
            isToken: true,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function extract(data) {
    return request({
        url: "/spreader/sextract/extract",
        headers: {
            isToken: true,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function getSpreaderExtract() {
    return request({
        url: "/spreader/sextract/getSpreaderExtract",
        headers: {},
        method: 'post',
        data: null,
    });
}


// WEBPACK FOOTER //
// ./src/api/spreader/extract.js